'use client';

import { useRemoveJob } from '@/modules/job/application';

import { useToast } from '@packages/web-design-systems';

export const useRemoveJobHandler = () => {
	const removeJob = useRemoveJob();
	const { showError, showSuccess } = useToast();

	const execute = async (jobId: string) => {
		const result = await removeJob.submit(jobId);

		if (result.isFailure) {
			showError({ title: 'Failed to remove job' });

			return;
		}

		showSuccess({ title: 'Job Removed' });
	};

	return { execute };
};
